import React from 'react'
import Marquee from '../Marquee/Marquee';
import MarqueeTwo from '../Marquee/MarqueeTwo';
import './Animations.css';

function Animations() {
  return (
    <div className='animation-section'>
      <Marquee/>
      <MarqueeTwo/>
    </div>
  )
}

export default Animations
